import React, { useEffect, useState, useCallback, useContext, useRef, useMemo } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';

import { SelectButton } from 'primereact/selectbutton';
import { Card as NextCard, Switch } from "@nextui-org/react";
import { Popover, Table, Tooltip as TooltipNext, Button as RevealButton, Progress } from '@nextui-org/react';
import Web3 from "web3";

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import {
    infoOutlineStyle, cardOutlineHeaderStyle, cardOutlineStyle, miniCardHeaderOutlineStyle, miniInfoOutlineStyle,
    infoOutlineInvertStyle, cardOutlineInvertHeaderStyle, cardOutlineInvertStyle, miniCardHeaderStyle, miniInfoStyle,
    infoStyle, cardStyle, cardHeaderInvertStyle, miniCardHeaderInvertStyle, miniInfoInvertStyle, cardHeaderStyle, cardOutlineSmallStyle
} from "./TileStyles";

import { formatTokenLabel, formatCurrencyExtended, formatPercentage, formatWalletAddress, formatDecimals, } from '../../utils';

import BigNumber from 'bignumber.js';
import { act } from "react-dom/test-utils";

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';  // USD icon
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import RadarIcon from '@mui/icons-material/Radar';

const containerStyle = {
    maxWidth: '1600px', // Adjust this value according to your preference
    margin: '0 auto', // Centers the container
    width: '100%', // Takes full width on smaller screens
};

const icons = {
    totalConverted: "pi pi-bolt",
    totalRewarded: "pi pi-gift",
    walletBalance: "pi pi-wallet",
    earned: "pi pi-check-circle",
    pendingRewards: "pi pi-clock"
};

const miniTokenCardStyle = (hasHoldings) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'start',
    width: '100%',
    padding: '12px',
    //outline: '1px solid grey',
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    borderRadius: '15px',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    color: 'black',
    //outline: hasHoldings ? '2px solid black' : 'none',
    backgroundColor: hasHoldings ? 'rgba(255, 255, 255, 1)' : 'rgba(210, 210, 210, 1)',
    // marginTop: '10px',
    // marginBottom: '10px',
});

const PendingRewardDetailsModal = React.memo(({ visible, onHide, token }) => {
    if (!token) return null;

    return (
        <Dialog header={`${token.name} - Deposit Queue Details`} visible={visible} style={{ maxWidth: '500px', width: '100%' }} onHide={onHide}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <div>
                    <strong>Your Position:</strong>
                </div>
                <div>{token.holderIndex}</div>

                <div>
                    <strong>Total Holders:</strong>
                </div>
                <div>{token.autoDepositShareholders.length}</div>

                <div>
                    <strong>Current Position:</strong>
                </div>
                <div>{token.reflectionPool.data.currentIndex}</div>

                <div>
                    <strong>Next Deposit:</strong>
                </div>
                <div>
                    {formatWalletAddress(
                        token.reflectionPool.data.currentIndex === token.autoDepositShareholders.length
                            ? token.autoDepositShareholders[0]
                            : token.autoDepositShareholders[token.reflectionPool.data.currentIndex]
                    )}
                </div>
            </div>
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <Button label="Close" icon="pi pi-times" onClick={onHide} />
            </div>
        </Dialog>
    );
});


const Dashboard = ({ ultraSelections, nativeSelections, selectionPairs, ultraTokenContracts, getTokenPrice, data }) => {

    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;

    const toast = useRef(null);

    const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
    const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;

    const [activePools, setActivePools] = useState([]);
    const [activeTokenData, setActiveTokenData] = useState({});
    const [totalConvertedUSD, setTotalConvertedUSD] = useState(0);
    const [totalRewardedUSD, setTotalRewardedUSD] = useState(0);
    const [totalWalletUSD, setTotalWalletUSD] = useState(0);
    const [totalPendingUSD, setTotalPendingUSD] = useState(0);
    const [totalEarnedUSD, setTotalEarnedUSD] = useState(0);


    const [isClaiming, setIsClaiming] = useState(false);
    const [isClaimingToken, setIsClaimingToken] = useState({});

    // State to manage modal visibility and selected token
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedToken, setSelectedToken] = useState(null);

    // Function to open the modal with the selected token
    const openDetailsModal = (token) => {
        setSelectedToken(token);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const closeDetailsModal = () => {
        setIsModalVisible(false);
        setSelectedToken(null);
    };


    const handleClaim = async () => {
        setIsClaiming(true);
        if (!isWalletConnected()) {
            console.error("Please connect to a wallet before interacting with the contract.");
            return;
        }
        try {
            const transaction = contracts.ultraDistributor.methods.claimAllCurrentDividends().send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

        } catch (error) {
            console.error("Error interacting with the Ultra Distributor contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Ultra Distributor contract: ${error.message}`, life: 3000 });
        }
        getActivePools();
        setIsClaiming(false);
    };


    const getActivePools = useCallback(async () => {
        if (contracts && contracts.ultraDistributor) {
            const activePools = await contracts.ultraDistributor.methods.getActivePools().call();
            setActivePools(activePools.activePools);
        }
    }, [contracts]);

    const handleClaimToken = useCallback(async (token) => {
        // Set the claiming state for the specific token to true
        setIsClaimingToken(prev => ({ ...prev, [token.address]: true }));

        if (!isWalletConnected()) {
            console.error("Please connect to a wallet before interacting with the contract.");
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please connect to a wallet before interacting with the contract.', life: 3000 });
            setIsClaimingToken(prev => ({ ...prev, [token.address]: false }));
            return;
        }

        try {
            const tokenAddress = token.address;

            // Initiate the transaction to claim dividends for the specific token
            const transaction = contracts.ultraDistributor.methods.claimDividends(tokenAddress).send({ from: account });

            // Handle the transaction hash event
            transaction.on("transactionHash", (hash) => {
                toast.current.show({
                    severity: 'info',
                    summary: 'Transaction Submitted',
                    detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`,
                    life: 3000
                });
            });

            // Await the transaction receipt
            await transaction;

            // Notify the user of the successful transaction
            toast.current.show({
                severity: 'success',
                summary: 'Transaction Success',
                detail: 'The transaction has been completed successfully.',
                life: 3000
            });

        } catch (error) {
            console.error("Error interacting with the Ultra Distributor contract:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Transaction Error',
                detail: `Error interacting with the Ultra Distributor contract: ${error.message}`,
                life: 3000
            });
        }

        // Refresh the active pools data
        getActivePools();

        // Reset the claiming state for the specific token
        setIsClaimingToken(prev => ({ ...prev, [token.address]: false }));
    }, [contracts, account, isWalletConnected, getActivePools]);




    const fetchTokenData = useCallback(async (tokenAddress) => {
        console.log("Fetching data for token:", tokenAddress);
        if (!contracts || !contracts.ultraDistributor || !ultraTokenContracts[tokenAddress] || !data?.pricingData) {
            return;
        }
        
        const reflectionPool = await contracts.ultraDistributor.methods.reflectionPoolAtERC20(tokenAddress).call();
        console.log("Reflection Pool:", reflectionPool);
        const holderShares = await contracts.ultraDistributor.methods.shares(account, tokenAddress).call();
        console.log("holderShares:", holderShares);
        const holderBalance = await ultraTokenContracts[tokenAddress].methods.balanceOf(account).call();
        console.log("Holder Balance:", holderBalance);
        const holderRewards = await contracts.ultraDistributor.methods.getTotalUnrealisedWithRealisedUndeposited(account, tokenAddress).call();
        const holderIndex = await contracts.ultraDistributor.methods.getHolderIndex(tokenAddress, account).call();
        const tokenName = await ultraTokenContracts[tokenAddress].methods.name().call();
        const tokenSymbol = await ultraTokenContracts[tokenAddress].methods.symbol().call();
        const tokenDecimals = await ultraTokenContracts[tokenAddress].methods.decimals().call();
        const totalSupply = await ultraTokenContracts[tokenAddress].methods.totalSupply().call();
        const distributorBalance = await ultraTokenContracts[tokenAddress].methods.balanceOf(contracts.ultraDistributor._address).call();
        const tokenPrice = getTokenPrice(tokenAddress);
        //console.log("Token Price:", tokenPrice);
        const autoDepositShareholders = await contracts.ultraDistributor.methods.getAutoDepositShareHolders(tokenAddress).call();

        console.log(`Fetched data for token ${tokenSymbol} (${tokenAddress})`);
        return {
            address: tokenAddress,
            name: tokenName,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            totalSupply: totalSupply,
            reflectionPool: reflectionPool,
            holderShares: holderShares,
            holderBalance: holderBalance,
            holderRewards: holderRewards,
            holderIndex: holderIndex,
            contract: ultraTokenContracts[tokenAddress],
            distributorBalance: distributorBalance,
            tokenPrice: tokenPrice,
            autoDepositShareholders: autoDepositShareholders
        };
    }, [contracts, ultraTokenContracts, getTokenPrice, account, data]);
    //[contracts, account, ultraTokenContracts, data?.pricingData]);


    const calculateTotalConvertedUSD = useCallback(() => {
        let total = new BigNumber(0);
        Object.values(activeTokenData).forEach(token => {
            //console.log(token);
            const supply = new BigNumber(token.totalSupply);
            const decimals = new BigNumber(10).pow(token.decimals);
            const price = new BigNumber(token.tokenPrice ? token.tokenPrice : 0);
            //console.log(price);
            const usdValue = supply.dividedBy(decimals).multipliedBy(price);
            //console.log(usdValue);
            total = total.plus(usdValue);
            //console.log(total);
        });
        setTotalConvertedUSD(total.toFixed(2));
    }, [activeTokenData]);

    useEffect(() => {
        if (!activeTokenData) return;
        console.log("Active Token Data:", activeTokenData);
        calculateTotalConvertedUSD();
    }, [activeTokenData]);

    useEffect(() => {
        if (!activeTokenData) return;
        const totalRewarded = Object.values(activeTokenData).reduce((acc, token) => {
            const totalDistributed = new BigNumber(token.reflectionPool.data.totalDistributed);
            const distributorBalance = new BigNumber(token.distributorBalance);
            const price = new BigNumber(token.tokenPrice ? token.tokenPrice : 0);
            const decimals = new BigNumber(10).pow(token.decimals);
            const rewardedUSD = totalDistributed.plus(distributorBalance).dividedBy(decimals).multipliedBy(price);
            return acc.plus(rewardedUSD);
        }, new BigNumber(0));

        const totalWallet = Object.values(activeTokenData).reduce((acc, token) => {
            const balance = new BigNumber(token.holderBalance);
            const price = new BigNumber(token.tokenPrice ? token.tokenPrice : 0);
            const decimals = new BigNumber(10).pow(token.decimals);
            const walletUSD = balance.dividedBy(decimals).multipliedBy(price);
            return acc.plus(walletUSD);
        }, new BigNumber(0));

        const totalPending = Object.values(activeTokenData).reduce((acc, token) => {
            const rewards = new BigNumber(token.holderRewards);
            const price = new BigNumber(token.tokenPrice ? token.tokenPrice : 0);
            const decimals = new BigNumber(10).pow(token.decimals);
            const pendingUSD = rewards.dividedBy(decimals).multipliedBy(price);
            return acc.plus(pendingUSD);
        }, new BigNumber(0));

        const totalEarned = Object.values(activeTokenData).reduce((acc, token) => {
            const realised = new BigNumber(token.holderShares.totalRealised);
            const price = new BigNumber(token.tokenPrice ? token.tokenPrice : 0);
            const decimals = new BigNumber(10).pow(token.decimals);
            const earnedUSD = realised.dividedBy(decimals).multipliedBy(price);
            return acc.plus(earnedUSD);
        }, new BigNumber(0));

        setTotalRewardedUSD(totalRewarded.toFixed(2));
        setTotalWalletUSD(totalWallet.toFixed(2));
        setTotalPendingUSD(totalPending.toFixed(2));
        setTotalEarnedUSD(totalEarned.toFixed(2));
    }, [activeTokenData]);



    useEffect(() => {
        if (!contracts || !contracts.ultraDistributor || !ultraTokenContracts) return;
        console.log("Active Pools:", activePools);
        if (activePools.length > 0 && account) {
            Promise.all(activePools.map(pool => fetchTokenData(pool))).then(tokenDataArray => {
                const validTokenDataArray = tokenDataArray.filter(tokenData => tokenData !== undefined && tokenData !== null);
                
                const tokenDataObject = validTokenDataArray.reduce((acc, tokenData) => {
                    acc[tokenData.address] = tokenData;
                    return acc;
                }, {});

                setActiveTokenData(tokenDataObject);
            }).catch(error => console.error("Error fetching token data:", error));
        }
    }, [activePools, account, contracts, ultraTokenContracts, fetchTokenData]);


    useEffect(() => {
        getActivePools();
    }
        , [contracts]);

    const hasRewards = () => {
        if (!activeTokenData) return false;
        return Object.values(activeTokenData).some(token => parseInt(token?.holderRewards) > 0);
    };

    const hasRewardsEarned = () => {
        if (!activeTokenData) return false;
        return Object.values(activeTokenData).some(token => parseInt(token?.holderShares?.totalRealised) > 0);
    };

    const hasBalance = () => {
        if (!activeTokenData) return false;
        return Object.values(activeTokenData).some(token => parseInt(token?.holderBalance) > 0);
    };



    const [radarView, setRadarView] = useState(localStorage.getItem('radarView') === 'true' || false);
    const [usdView, setUsdView] = useState(localStorage.getItem('usdView') === 'true' || false);


    useEffect(() => {
        radarView ? localStorage.setItem('radarView', 'true') : localStorage.setItem('radarView', 'false');
    }, [radarView]);

    // Persist usdView to localStorage
    useEffect(() => {
        usdView ? localStorage.setItem('usdView', 'true') : localStorage.setItem('usdView', 'false');
    }, [usdView]);



    return (
        // <div style={containerStyle}
        // >
        // <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>
        <div >
            <Card title={"UltraBlue Stats"} style={{
                backgroundImage: 'linear-gradient(180deg, rgba(0, 155, 255, 0.75) 0%, rgba(0, 155, 215, 0.75) 100%)',
                borderRadius: '15px',
                border: 'none',
                marginTop: '10px',
                marginBottom: '10px',
                color: '#FFFFFF',
                fontFamily: 'Inter, sans-serif',
                padding: '3px',
            }}>
                <div style={{ marginTop: "10px" }}>


                    <div
                        style={{
                            // backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            // padding: '10px',
                            // paddingBottom: '15px',
                            // borderRadius: '15px',
                            // marginTop: '10px',
                            // marginBottom: '10px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div>
                            <div style={{ fontSize: "13px", marginTop: "15px", alignContent: 'center' }}>
                                {/* <i className={icons.totalConverted}></i>  */}
                                Total Converted Value<br />
                                <div style={{ fontSize: "20px", fontWeight: 'bold', }}>

                                    {formatCurrencyExtended(totalConvertedUSD)}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: "13px", marginTop: "15px", alignContent: 'center' }}>
                                {/* <i className={icons.totalRewarded}></i> */}
                                Total Rewarded<br />
                                <div style={{ fontSize: "20px", fontWeight: 'bold', }}>
                                    {formatCurrencyExtended(totalRewardedUSD)}
                                </div>
                            </div>

                        </div>
                    </div>



                </div>
                <Toast ref={toast} />
            </Card>
            <div >
                {//(hasBalance() || hasRewards() || hasRewardsEarned()) &&
                    <Card title={"Your UltraBlue"} style={{
                        backgroundImage: 'linear-gradient(180deg, rgba(0, 110, 255, 0.75) 0%, rgba(0, 110, 215, 0.75) 100%)',
                        borderRadius: '15px',
                        border: 'none',
                        marginTop: '10px',
                        marginBottom: '10px',
                        color: '#FFFFFF',
                        fontFamily: 'Inter, sans-serif',
                        padding: '3px',
                    }}>
                        <div style={{ marginTop: "10px" }}>

                            {/* <div
                                style={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    padding: '10px',
                                    paddingBottom: '15px',
                                    borderRadius: '15px',
                                    marginTop: '10px',
                                    marginBottom: '10px',
                                    flexDirection: 'row',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            > */}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '10px', marginTop: '10px', marginBottom: '10px' }}>
                            
                                <div>
                                    <div style={{ fontSize: "13px", marginTop: "15px", alignContent: 'center' }}>
                                        {/*  <i className={icons.walletBalance}></i>   */}
                                        Wallet Balance<br />
                                        <div style={{ fontSize: "20px", fontWeight: 'bold', }}>
                                            {formatCurrencyExtended(totalWalletUSD)}
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <div style={{ fontSize: "13px", marginTop: "15px", alignContent: 'center' }}>
                                        {/*  <i className={icons.earned}></i>   */}
                                        Total Earned<br />
                                        <div style={{ fontSize: "20px", fontWeight: 'bold', }}>
                                            {formatCurrencyExtended(totalEarnedUSD)}
                                        </div>
                                    </div>

                                </div>

                                <div>
                                    <div style={{ fontSize: "13px", marginTop: "15px", alignContent: 'center' }}>
                                        {/*  <i className={icons.pendingRewards}></i>   */}
                                        Pending Rewards<br />
                                        <div style={{ fontSize: "20px", fontWeight: 'bold', }}>
                                            {formatCurrencyExtended(totalPendingUSD)}
                                        </div>
                                    </div>

                                </div>
                            


                                {/* "Claim All" Button */}
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                    {isClaiming ? (
                                        <Progress
                                            indeterminated
                                            color="gradient"
                                            status="secondary"
                                            size="xl"
                                        />
                                    ) : (
                                        <Button
                                            rounded
                                            severity="primary"
                                            size="small"
                                            style={{ width: '115px', justifyContent: 'center' }}
                                            onClick={handleClaim}
                                        >
                                            Claim All
                                        </Button>
                                    )}
                                </div>
                            </div>
                            <div //style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '10px', marginTop: '10px' }}
                            >



                                <div style={{ flex: '1 1 60%', minWidth: '300px' }}>
                                    {/* Token Cards */}

                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '5px' }}>
                                        <Switch
                                            checked={radarView}
                                            size="md"
                                            onChange={() => setRadarView(prev => !prev)}
                                            iconOn={<RocketLaunchIcon />}
                                            iconOff={<RadarIcon />}
                                            style={{ color: 'black' }}
                                        />
                                        <Switch
                                            checked={usdView}
                                            size="md"
                                            onChange={() => setUsdView(prev => !prev)}
                                            iconOn={<AttachMoneyIcon />} // Icon for USD view
                                            iconOff={<CurrencyBitcoinIcon />} // Icon for Crypto view
                                            style={{ color: 'black' }}
                                        />
                                    </div>

                                    <div style={{
                                        flexDirection: 'column',
                                        display: 'grid',
                                        flexWrap: 'wrap',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                        justifyContent: 'flex-start',
                                        gap: '10px',
                                        paddingTop: '10px',
                                    }}>
                                        {activeTokenData && Object.values(activeTokenData)
                                            //.filter(token => parseInt(token?.holderBalance) > 0)
                                            //sort by parseInt(token?.holderBalance) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice
                                            .sort((a, b) => {
                                                return parseInt(b?.holderBalance) / (10 ** parseInt(b?.decimals)) * b?.tokenPrice - parseInt(a?.holderBalance) / (10 ** parseInt(a?.decimals)) * a?.tokenPrice;
                                            })
                                            .map(token => (
                                                <NextCard
                                                    key={token?.address.toLowerCase()} // Use unique identifier
                                                    isHoverable={!radarView}
                                                    isPressable={!radarView}
                                                    //onClick={() => handleTokenCardClick(token)}
                                                    style={miniTokenCardStyle(parseInt(token?.holderBalance) > 0)}
                                                >
                                                    <NextCard.Body style={{ padding: '3px', overflow: 'auto' }}>
                                                        {/* Header Section */}
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                                                                <img src={ultraSelections.find(t => t.address === token?.address).img} alt={token?.name} style={{ width: '30px', height: '30px' }} />
                                                                <span>{token.symbol}</span>
                                                            </div>
                                                            <div>
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                                                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                                        {usdView
                                                                            ? formatCurrencyExtended(parseInt(token?.holderBalance) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice)
                                                                            : formatDecimals(token?.holderBalance, token?.decimals)
                                                                        }
                                                                    </div>
                                                                    <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                        {!usdView
                                                                            ? formatCurrencyExtended(parseInt(token?.holderBalance) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice)
                                                                            : formatDecimals(token?.holderBalance, token?.decimals)
                                                                        }
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* Ultra Token Details */}
                                                        {!radarView && (
                                                            <div style={{ marginTop: '10px' }}>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Total Converted: {formatDecimals(token?.totalSupply, token?.decimals)} {'(' + formatCurrencyExtended(parseInt(token?.totalSupply) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice) + ')'}
                                                                </div>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Total Rewarded: {formatDecimals((parseInt(token?.reflectionPool?.data.totalDistributed) + parseInt(token?.distributorBalance)), token?.decimals)} {'(' + formatCurrencyExtended((parseInt(token?.reflectionPool?.data.totalDistributed) + parseInt(token?.distributorBalance)) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice) + ')'}
                                                                </div>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Reward Position: {formatPercentage(parseInt(token?.holderBalance) / parseInt(token?.totalSupply))}
                                                                </div>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Price: {formatCurrencyExtended(token.tokenPrice)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {radarView && (
                                                            <>
                                                                <div style={{ marginTop: '10px' }}>
                                                                    <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                        Total Earned: {formatDecimals(token?.holderShares?.totalRealised, token?.decimals)} {'(' + formatCurrencyExtended(parseInt(token?.holderShares?.totalRealised) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice) + ')'}
                                                                    </div>
                                                                    <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                        Pending: {formatDecimals(token.holderRewards, token?.decimals)} {'(' + formatCurrencyExtended(parseInt(token.holderRewards) / (10 ** parseInt(token?.decimals)) * token?.tokenPrice) + ')'}
                                                                    </div>
                                                                </div>
                                                                <div style={{
                                                                    marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center',
                                                                    textAlign: 'center', alignContent: 'center',
                                                                }}>
                                                                    {parseInt(token.holderRewards) > 0 && <Button
                                                                        rounded
                                                                        severity="primary"
                                                                        size="small"
                                                                        style={{ flex: 1, alignSelf: 'center', justifyContent: 'center' }}
                                                                        onClick={() => handleClaimToken(token)}
                                                                        disabled={isClaimingToken[token.address]}
                                                                    >
                                                                        {isClaimingToken[token.address] ? 'Claiming...' : `Claim`}
                                                                    </Button>}
                                                                    <Button
                                                                        rounded
                                                                        severity="secondary"
                                                                        size="small"
                                                                        style={{ flex: 1, alignSelf: 'center', justifyContent: 'center' }}
                                                                        onClick={() => openDetailsModal(token)}
                                                                    >
                                                                        Deposit Details
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* {!radarView && (
                                                            <div style={{ marginTop: '10px' }}>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Market Cap: {token.totalSupply !== undefined ? `${formatCurrencyExtended(calculateMarketCap(token.totalSupply, token.decimals, token.price))}` : <LoadingSmallContent />}
                                                                </div>
                                                                <div style={{ fontSize: '14px', color: 'grey' }}>
                                                                    Price: {token.price !== undefined ? `${formatCurrencyExtended(token.price)}` : <LoadingSmallContent />}
                                                                </div>
                                                            </div>
                                                        )} */}

                                                        {/* Actions Section */}
                                                        {/* {radarView && <div>
                                                            <RewardsPending token={token} account={account} contracts={contracts} imageReferences={imageReferences} tokenSelections={tokenSelections} enableClaiming={true} refreshData={refreshData} />
                                                        </div>} */}
                                                    </NextCard.Body>
                                                </NextCard>
                                            ))
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                        <Toast ref={toast} />
                    </Card>}
            </div>
            <PendingRewardDetailsModal
                visible={isModalVisible}
                onHide={closeDetailsModal}
                token={selectedToken}
            />
        </div>
    );
}

export default React.memo(Dashboard);

